// bao migrate skip

import Bao from "./../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";


var bindingName = "baoSelector";
function _defaults() {
    this.Items = ko.observableArray();
    this.mousedown = ko.observable(false);
    this.Visible = ko.observable(false);
    this.Committed = function () { };
}
function _getApi(element) {
    return $(element).data(bindingName);
}
ko.bindingHandlers[bindingName] = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        _createControl(element, valueAccessor);
        _registerEvents(element);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            var api = $(element).data(bindingName);
            $(element).off("focus." + bindingName);
            $(element).off("blur." + bindingName);
            $(element).off("keydown." + bindingName);
            api.__cleaner__();
            api.$container.remove();
        });
    }, update: function (element, valueAccessor) {
        var api = _getApi(element);
        api.options = ko.createBindingConfig(valueAccessor(), api.options);
    }
};
function _createControl(element, valueAccessor) {
    var api : any = {
        ViewModel: new ViewModel(element),
        __cleaner__: ko.reattachHelper(element)
    };
    api.options = ko.createBindingConfig(valueAccessor(), new _defaults());
    var $listItem = $("<a href='#' class='list-group-item list-group-item-warning' data-bind='css: {active: $index() == $root.selectedIndex()}, click: function() { $root.toggleItem($data);}'><span class='fal fa-check-square' data-bind='visible: removed() == false'></span><span class='fal fa-square' data-bind='visible: removed'></span><span data-bind='text: Value'></span></a>");
    var $resultList = $("<div class='bao-selector list-group autocompletelist' data-bind='foreach: Items, visible: visible'}></div>")
        .append($listItem);
    var $title = $("<div class='selector-title list-group' data-bind='visible: TitleVisible'><a href='#' class='list-group-item list-group-item-warning' data-bind='click: titleClicked'><strong><i class='fal fa-check-square'></i><span class='title-text' data-bind='text: TitleText'></span></strong></a></div>");
    $resultList.on("mousedown", $.proxy(api.ViewModel.mouseDown, api.ViewModel));
    $resultList.on("mouseup", $.proxy(api.ViewModel.mouseUp, api.ViewModel));
    $title.on("mousedown", $.proxy(api.ViewModel.mouseDown, api.ViewModel));
    $title.on("mouseup", $.proxy(api.ViewModel.mouseUp, api.ViewModel));
    if (window.Hammer != undefined) {
        window.Hammer($resultList[0]).on("touch", $.proxy(api.ViewModel.mouseDown, api.ViewModel));
        window.Hammer($resultList[0]).on("release", $.proxy(api.ViewModel.mouseUp, api.ViewModel));
    }
    var $popupcontainer = $("<div class='popupcontainer'></div>");
    if ($(element).data("baoAutoComplete") != null) {
        api.$container = $(element).data("baoAutoComplete").$container;
        $popupcontainer = $(".popupcontainer", api.$container);
    }
    else {
        var $wrapContainer = $("<div></div>").addClass("autocompletecontainer");
        $(element).wrap($wrapContainer);
        api.$container = $(element).parent();
    }
    api.$container.addClass("baoselectorcontainer");
    $popupcontainer.prepend($resultList);
    $popupcontainer.prepend($title);
    api.$container.append($popupcontainer);
    api.$list = $resultList;
    api.ViewModel.Items = api.options.Items;
    api.ViewModel.visible = api.options.Visible;
    api.ViewModel.TitleText = ko.computed(function () {
        ko.utils.arrayForEach(api.ViewModel.Items(), function (item: any) {
            if (item.removed == undefined) {
                item.removed = ko.observable(false);
            }
        });
        return " " +
            ko.utils.arrayFilter(api.ViewModel.Items(), function (item : any) {
                return item.removed() == false;
            }).length;
    });
    ko.utils.arrayForEach(api.ViewModel.Items(), function (i : any) {
        if (i.removed == undefined) {
            i.removed = ko.observable(false);
        }
    });
    ko.applyBindings(api.ViewModel, $resultList[0]);
    ko.applyBindings(api.ViewModel, $title[0]);
    $(element).data(bindingName, api);
}
function _focusEvent(element) {
    var baoAutoCompleteApi = $(element).data("baoAutoComplete");
    if (!$(element).is("[readonly]") && (baoAutoCompleteApi == undefined || baoAutoCompleteApi.ViewModel.visible() == false)) {
        var api = _getApi(element);
        api.ViewModel.visible(true);
        api.ViewModel.TitleVisible(true);
        $(element).val("");
        $(element).change();
    }
}
function _blurEvent(element) {
    var api = _getApi(element);
    if (api.options.mousedown() == false) {
        api.ViewModel.visible(false);
        api.ViewModel.TitleVisible(false);
        _clearItems(element);
        _setText(element);
        api.ViewModel.selectedIndex(null);
        api.options.Committed();
    }
}
function _clearItems(element) {
    var api = _getApi(element);
    api.ViewModel.Items.remove(function (item) { return item.removed != undefined && item.removed() == true; });
}
function _setText(element) {
    if (!$(element).is("[readonly]")) {
        var api = _getApi(element);
        var t = "";
        ko.utils.arrayForEach(api.ViewModel.Items(), function (item: any) {
            if (t != "") {
                t = t + ", ";
            }
            t = t + ko.unwrap(item.Value);
        });
        $(element).val(t);
        $(element).change();
    }
}
function _selectNext(element) {
    var api = _getApi(element);
    var array = api.ViewModel.Items();
    if (array != null && array.length > 0) {
        if (api.ViewModel.selectedIndex() == null) {
            api.ViewModel.selectedIndex(0);
        }
        else {
            if (api.ViewModel.selectedIndex() < array.length - 1) {
                api.ViewModel.selectedIndex(api.ViewModel.selectedIndex() + 1);
            }
        }
    }
}
function _selectPrev(element) {
    var api = _getApi(element);
    var array = api.ViewModel.Items();
    if (array != null && array.length > 0) {
        if (api.ViewModel.selectedIndex() == null) {
            api.ViewModel.selectedIndex(array.length - 1);
        }
        else {
            if (api.ViewModel.selectedIndex() != 0) {
                api.ViewModel.selectedIndex(api.ViewModel.selectedIndex() - 1);
            }
        }
    }
}
function _registerEvents(element) {
    var api = _getApi(element);
    var config = api.ViewModel.options;
    $(element).on("focus." + bindingName, function () {
        _focusEvent(element);
    });
    $(element).on("blur." + bindingName, function () {
        _blurEvent(element);
    });
    $(element).on("keydown." + bindingName, function (e) {
        _keydownEvent(element, e);
    });
}
function _keydownEvent(element, e) {
    var api = _getApi(element);
    if (api.ViewModel.visible()) {
        if (e.keyCode == 9) {
        }
        else if (e.keyCode == 27) {
            api.ViewModel.selectedIndex(null);
            Bao.Utils.stopPropagation(e);
            e.preventDefault();
        }
        else if (e.keyCode == 40) {
            if (api.ViewModel.visible()) {
                _selectNext(element);
                Bao.Utils.stopPropagation(e);
                e.preventDefault();
            }
        }
        else if (e.keyCode == 38) {
            if (api.ViewModel.visible()) {
                _selectPrev(element);
                Bao.Utils.stopPropagation(e);
                e.preventDefault();
            }
        }
        else if (e.keyCode == 32) {
            if (api.ViewModel.selectedIndex() != null) {
                var selectedItem = api.ViewModel.Items()[api.ViewModel.selectedIndex()];
                if (selectedItem != null) {
                    api.ViewModel.toggleItem(selectedItem);
                }
                Bao.Utils.stopPropagation(e);
                e.preventDefault();
            }
        }
    }
}
function ViewModel(element) {
    var self = this;
    self.element = element;
    self.visible = ko.observable(false);
    self.TitleVisible = ko.observable(false);
    self.selectedIndex = ko.observable();
}
ViewModel.prototype.toggleItem = function (item) {
    $(this.element).focus();
    item.removed(!item.removed());
    var api = _getApi(this.element);
    api.options.mousedown(false);
};
ViewModel.prototype.mouseDown = function () {
    var api = _getApi(this.element);
    api.options.mousedown(true);
};
ViewModel.prototype.mouseUp = function () {
};
ViewModel.prototype.titleClicked = function () {
    var api = _getApi(this.element);
    var baoAutoCompleteApi = $(this.element).data("baoAutoComplete");
    if (baoAutoCompleteApi != null) {
        baoAutoCompleteApi.ViewModel.visible(false);
    }
    api.options.mousedown(false);
    $(this.element).focus();
    this.visible(true);
    this.selectedIndex(null);
    $(this.element).val("");
    $(this.element).change();
};
